import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./root-reducer";
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";
import { exposeGlobal } from "@/lib/utils/debug";

const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Expose the Redux store for debugging in development
exposeGlobal("store", store);

// Define AppThunk type to handle thunks globally
// export type AppThunk<ReturnType = void> = ThunkAction<
//   ReturnType,
//   RootState,
//   undefined,
//   Action<string>
// >;
export default store;
